'use client';

import { useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router';

import { PATHS } from 'src/routes/paths';

import { SplashScreen } from 'src/components/loading-screen';

import { useNavigate } from 'src/hooks/use-navigate';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function GuestGuard({ children }: Props) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const returnTo = searchParams.get('returnTo') || PATHS.root;

  const { authenticated } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      navigate(returnTo, { replace: true });
    }
  }, [authenticated, returnTo, navigate]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
